export class StorePermission {
  hasViewStoreList = false;
  hasViewStoreRequestList = false;

  checkPermission(authGuardService) {
    this.hasViewStoreList = authGuardService.checkPermission([
      'store_v',
      'store_eq',
      'store_locksale',
      'store_edit_m',
      'store_terminate'
    ]);
    this.hasViewStoreRequestList = authGuardService.checkPermission([
      'store_new_m',
      'store_new_req_v',
      'store_edit_m',
      'store_edit_req_v',
      'store_app'
    ]);
  }
}
